import axiosClient from './axiosClient';
import { cachedRequest } from './requestCache';

export const fetchDailyGames = async () =>
    cachedRequest('games:daily', async () => {
        const response = await axiosClient.post('/v1/challenges/games');
        if (response.data && response.data.success) {
            return response.data.data; // Return the array of games
        }
        throw new Error(response.data.errors || 'Failed to fetch daily games');
    });

/**
 * Fetch available games for selection
 * @returns {Promise} Response from the API
 */
export const fetchAvailableGames = async () => {
  try {
    const response = await axiosClient.get('/v1/daily-challenges/games');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchGameChallenges = async (gameId) => {
   try {
    const response = await axiosClient.post('/v1/daily-challenges/challenges', { gameId });
    return response.data; 
   } catch (error) {
    throw error;
   }
}

export const submitChallengeEntry = async (entryImage, challengeId) => {
  const formData = new FormData();
  formData.append('entryImage', entryImage);
  formData.append('challengeId', challengeId);

  try {
    const response = await axiosClient.post('/v1/daily-challenges/entry', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitGameEntry = async (gameData) => {
  try {
    const response = await axiosClient.post('/v1/esl-games/enter', gameData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitGameExit = async (gameData) => {
  try {
    const response = await axiosClient.post('/v1/esl-games/exit', gameData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const listEslGames = async () =>
  cachedRequest('games:esl', async () => {
    const response = await axiosClient.get('/v1/esl-games/check');
    return response.data;
  });